import React, { useCallback } from 'react'
import { t } from 'i18next'
import { CSVLink } from 'react-csv'
import GlSpacer from '../../../share/GlSpacer'
import { ReactComponent as CrossIcon } from '../../../../assets/icons/app/cross.icon.svg'
import { ReactComponent as DownloadIcon } from '../../../../assets/icons/download.icon.svg'
import AnalyticDetailsTable from './table/AnalyticDetailsTable'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  selectAnalyticDetailsStateAnalyticDetailsAuthorsInput,
  selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  selectAnalyticDetailsStateAuthorDetailsSelected,
} from '../../../../store/getters/analytics-details/analytic-details-v2.getters'
import { AuthorMirrorAuthorInterface } from '../../../../core/interface/report/author-mirror-author.interface'
import { analyticDetailsV2StateGetAuthorDetailsData } from '../../../../store/actions/analytics-details/analytic-details-v2.actions'
import { sanitizeStringForFileSafeName } from '../../../../core/utils/filename-sanitizer.utils'

const AuthorMirrorListCard = ({
  authorIdHovered,
  handleCloseList,
}: {
  authorIdHovered: string | null
  handleCloseList: () => void
}) => {
  const onClickCloseButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    handleCloseList()
  }

  const authorsInput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsAuthorsInput,
  )

  const authorsOutput = useAppSelector(
    selectAnalyticDetailsStateAnalyticDetailsAuthorsOutput,
  )

  const dispatch = useAppDispatch()

  const authorDetailsSelected = useAppSelector(
    selectAnalyticDetailsStateAuthorDetailsSelected,
  )

  const handleAuthorSelected = useCallback(
    (authorDetails: AuthorMirrorAuthorInterface | null) => {
      if (!authorDetails) {
        return
      }

      void dispatch(
        analyticDetailsV2StateGetAuthorDetailsData({ authorDetails }),
      )
    },
    [authorDetailsSelected],
  )

  let index = 0
  const csvData = authorsOutput.map((output) => {
    index += 1
    return {
      rank: index,
      proximity: Math.round((1 - (output.distance ?? 0)) * 1000) / 10,
      author: output.author.name,
    }
  })

  return (
    <div className="flex flex-col basis-1/3 gap-4">
      <div className="flex flex-row items-center justify-between gap-1">
        <GlSpacer />
        <button
          type="button"
          className="flex flex-row items-center justify-center gap-2 p-2 bg-[#e9e9e9] rounded"
        >
          <DownloadIcon className="w-4 h-4" />
          <CSVLink
            filename={`Auteurs.miroirs.Gleeph.de.${authorsInput
              .map((author) => sanitizeStringForFileSafeName(author.name ?? ''))
              .join('.')}.csv`}
            data={csvData}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <span>{t('downloadResults')}</span>
          </CSVLink>
        </button>
        <button
          type="button"
          className="flex flex-row items-center justify-center gap-2 p-2 bg-[#e9e9e9] rounded"
          onClick={onClickCloseButton}
        >
          <CrossIcon className="w-4 h-4" />
          <span>Fermer</span>
        </button>
      </div>
      <div className="relative flex-auto flex flex-col rounded-xl bg-white">
        <AnalyticDetailsTable
          authorDetailsSelected={authorDetailsSelected}
          authorsOutput={authorsOutput}
          isLoadingReloadOutput={false}
          handleAuthorSelected={handleAuthorSelected}
          authorIdHovered={authorIdHovered}
        />
      </div>
    </div>
  )
}

export default AuthorMirrorListCard
